/* お気に入り(ウィッシュリスト・自前) 2026-09-06
 * ------------------------------------------------------------------
 * Wishlist Hero の置き換え。設定は snippets/wishlist-head.liquid が window.SolefiaWishlist に出す。
 *
 * 【持ち方】
 *   ・端末(localStorage)が主。押した瞬間に反映し、オフラインでも動く。
 *     保存形: { items:[{v,h,s,t,p,a}], adds:{v:item}, removes:{v:外した日時} }
 *       v=バリエーションid  h=商品ハンドル  s=SKU  t=バリエーション名  p=商品名  a=入れた日時(ISO)
 *     adds / removes は「まだ商品DBに送れていない変更」。送れたら消す。
 *   ・商品DB(wishlist_api.php)には、貯めた変更をまとめて送り(sync)、返ってきた一覧を正とする。
 *     持ち主は 未ログイン=GA4の訪問者ID(_gaクッキー) / ログイン中=顧客ID(+署名)。
 *     ログイン中に訪問者IDも送ると、商品DB側で端末の分が顧客に合流する。
 *   ・訪問者IDが取れない端末(クッキー削除・広告ブロッカー)は端末だけで動く。
 *
 * 【描くもの】
 *   ・商品ページの♡ボタン(.wl-product)           … 選択中のバリエーションを入れる/外す
 *   ・ヘッダーのハートの件数(.wl-header__count)
 *   ・専用ページ([data-wl-page])の一覧(右ドロワーは 2026-09-06 夜に廃止。ヘッダーのハートは /pages/wishlist へのリンク)
 *     商品名・写真・価格・在庫は /products/ハンドル.js から毎回取る(古い価格が残らない)
 *   ・トースト(#WishlistToast)
 *
 * 【共有リンク】 /pages/wishlist?v=ハンドル:バリエーションid,ハンドル:バリエーションid,…
 *   受け取った人のブラウザが Shopify から商品情報を読んで描く(商品DBは使わない)。
 */
(function () {
  'use strict';
  var CFG = window.SolefiaWishlist;
  if (!CFG || !CFG.store) return;

  var KEY = 'wl_' + CFG.store + '_v1';
  var SYNC_DELAY = 600;

  /* ================================================================
     保存(localStorage)
     ================================================================ */
  var state = load();

  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      var d = raw ? JSON.parse(raw) : null;
      if (d && Array.isArray(d.items)) {
        return { items: d.items.filter(function (i) { return i && i.v && i.h; }), adds: d.adds || {}, removes: d.removes || {} };
      }
    } catch (e) { /* プライベートモード等 */ }
    return { items: [], adds: {}, removes: {} };
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* 保存できなくても動かす */ }
  }

  /* ================================================================
     持ち主(訪問者ID / 顧客ID)
     ================================================================ */
  function visitorId() {
    var m = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
    if (!m) return '';
    var v = decodeURIComponent(m[1]);
    var mm = v.match(/^GA\d\.\d\.(\d+\.\d+)$/);
    return mm ? mm[1] : '';
  }
  function canSync() { return !!(CFG.customer || visitorId()); }

  /* ================================================================
     中身の操作
     ================================================================ */
  function nowIso() { return new Date().toISOString(); }
  function has(v) {
    v = String(v);
    return state.items.some(function (i) { return i.v === v; });
  }
  function add(item, silent) {
    var v = String(item.v);
    if (!v || !item.h || has(v)) return false;
    var rec = { v: v, h: String(item.h), s: item.s || '', t: item.t || '', p: item.p || '', a: nowIso() };
    state.items.unshift(rec);
    delete state.removes[v];
    state.adds[v] = rec;
    save();
    if (!silent) emit();
    scheduleSync();
    return true;
  }
  function remove(v, silent) {
    v = String(v);
    if (!has(v)) return false;
    state.items = state.items.filter(function (i) { return i.v !== v; });
    delete state.adds[v];
    state.removes[v] = nowIso();
    save();
    if (!silent) emit();
    scheduleSync();
    return true;
  }
  function clearAll() {
    state.items.slice().forEach(function (i) { remove(i.v, true); });
    emit();
  }
  function emit() {
    renderAll();
    try { document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: state.items.length } })); } catch (e) { /* 古いブラウザ */ }
  }

  /* ================================================================
     商品DBとの同期
     ================================================================ */
  var syncTimer = null;
  var syncing = false;
  var syncAgain = false;

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, SYNC_DELAY);
  }

  function mysqlToIso(s) {
    // "2026-09-06 12:34:56"(日本時間) → ISO
    if (!s) return nowIso();
    var d = new Date(String(s).replace(' ', 'T') + '+09:00');
    return isNaN(d.getTime()) ? nowIso() : d.toISOString();
  }

  function sync() {
    if (!canSync()) return Promise.resolve();
    if (syncing) { syncAgain = true; return Promise.resolve(); }
    syncing = true;

    var adds = Object.keys(state.adds).map(function (k) {
      var i = state.adds[k];
      return { variant_id: i.v, handle: i.h, sku: i.s || '', variant: i.t || '', product_title: i.p || '', added_at: i.a };
    });
    var removes = Object.keys(state.removes).map(function (k) {
      return { variant_id: k, deleted_at: state.removes[k] };
    });

    var body = new URLSearchParams();
    body.set('store', CFG.store);
    body.set('visitor_id', visitorId());
    if (CFG.customer) {
      body.set('customer_id', CFG.customer.id);
      body.set('customer_sig', CFG.customer.sig);
    }
    body.set('adds', JSON.stringify(adds));
    body.set('removes', JSON.stringify(removes));

    return fetch(CFG.api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: body.toString(),
      keepalive: true
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.ok) throw new Error('sync failed');
        // 送れた変更を「未送信」から外す(送信中に同じ商品を触っていたら残す)
        adds.forEach(function (a) {
          var p = state.adds[a.variant_id];
          if (p && p.a === a.added_at) delete state.adds[a.variant_id];
        });
        removes.forEach(function (r) {
          if (state.removes[r.variant_id] === r.deleted_at) delete state.removes[r.variant_id];
        });
        // 商品DBの一覧を正にし、まだ送っていない端末の変更を重ねる
        var merged = (data.items || []).map(function (i) {
          return { v: String(i.variant_id), h: String(i.handle || ''), s: i.sku || '', t: i.variant || '', p: i.product_title || '', a: mysqlToIso(i.added_at) };
        }).filter(function (i) { return i.h && !state.removes[i.v]; });
        Object.keys(state.adds).forEach(function (k) {
          if (!merged.some(function (i) { return i.v === k; })) merged.unshift(state.adds[k]);
        });
        merged.sort(function (x, y) { return (y.a || '').localeCompare(x.a || ''); });
        var changed = JSON.stringify(merged.map(function (i) { return i.v; })) !== JSON.stringify(state.items.map(function (i) { return i.v; }));
        state.items = merged;
        save();
        if (changed) emit();
      })
      .catch(function () { /* 次の変更のときにまとめて送り直す */ })
      .then(function () {
        syncing = false;
        if (syncAgain) { syncAgain = false; scheduleSync(); }
      });
  }

  /* ================================================================
     商品情報(/products/ハンドル.js)
     ================================================================ */
  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  // お届け時期(variant.metafields.custom.otodoke)。/products/ハンドル.js には入らないので
  // templates/product.wl.liquid(?view=wl)から {variant_id: 文言} を取る(商品ページと同じ文言にするため)
  var deliveryCache = {};
  function fetchDelivery(handle) {
    if (!deliveryCache[handle]) {
      deliveryCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=wl', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .catch(function () { return {}; });
    }
    return deliveryCache[handle];
  }
  function imageUrl(src, width) {
    if (!src) return '';
    src = String(src).replace(/^\/\//, 'https://');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function resolveItem(item) {
    return Promise.all([fetchProduct(item.h), fetchDelivery(item.h)]).then(function (res) {
      var p = res[0];
      var deliveryMap = res[1] || {};
      if (!p) return { item: item, missing: true, title: item.p || item.h, variantTitle: item.t || '', url: '/products/' + item.h };
      var variant = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === item.v) { variant = p.variants[i]; break; }
      }
      var img = (variant && variant.featured_image && variant.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
      return {
        item: item,
        missing: false,
        title: p.title,
        url: '/products/' + p.handle + (variant ? '?variant=' + variant.id : ''),
        image: imageUrl(img, 480),
        price: variant ? variant.price : p.price,
        available: variant ? !!variant.available : false,
        variantTitle: variant ? (variant.title === 'Default Title' ? '' : variant.title) : (item.t || ''),
        sku: variant ? (variant.sku || '') : (item.s || ''),
        delivery: variant && typeof deliveryMap[String(variant.id)] === 'string' ? deliveryMap[String(variant.id)].trim() : ''
      };
    });
  }

  /* ================================================================
     描画の部品
     ================================================================ */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function yen(cents) {
    var n = Math.round(Number(cents || 0) / 100);
    return '¥' + n.toLocaleString('ja-JP');
  }
  function jdate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate();
  }
  var HEART = '<svg class="wl-heart" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
  var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var MAIL = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="1"/><path d="m3 7 9 6 9-6"/></svg>';

  function emptyHtml(shared) {
    return '<div class="wl-empty">' + HEART +
      '<div>' + (shared ? '共有された一覧に商品がありません。' : 'お気に入りはまだありません。<br>商品ページの ♡ で追加できます。') + '</div>' +
      '<a class="wl-btn wl-btn--ghost" href="/collections/all">商品を見る</a></div>';
  }
  function skeletonHtml(mode, n) {
    var one = '<div class="wl-card"><div class="wl-skel"></div><div class="wl-skel-line" style="width:90%"></div><div class="wl-skel-line" style="width:50%"></div></div>';
    var s = '';
    for (var i = 0; i < n; i++) s += one;
    return s;
  }
  function stockHtml(r) {
    if (r.missing) return '<div class="wl-card__stock ng">現在は取り扱いがありません</div>';
    if (!r.available) return '<div class="wl-card__stock ng">売り切れ</div>';
    // 商品ページの「お届け時期: 3～4週間後お届け」と同じ文言を出す(取れなければ「在庫あり」)
    return '<div class="wl-card__stock">' + (r.delivery && r.delivery !== '在庫なし' ? 'お届け時期: ' + esc(r.delivery) : '在庫あり') + '</div>';
  }
  function actionHtml(r, wide) {
    var cls = 'wl-btn ' + (wide ? 'wl-btn--wide ' : '');
    if (r.missing) return '';
    if (r.available) {
      return '<button type="button" class="' + cls + 'wl-btn--solid" data-wl-cart="' + esc(r.item.v) + '">カートに追加</button>';
    }
    return '<a class="' + cls + 'wl-btn--ghost" href="' + esc(r.url) + '">' + MAIL + '入荷したらメールでお知らせ</a>';
  }
  function cardHtml(r, shared) {
    var v = esc(r.item.v);
    return '<div class="wl-card' + (r.missing ? ' wl-card--missing' : '') + '" data-wl-item="' + v + '">' +
      '<a class="wl-img" href="' + esc(r.url) + '">' +
        (r.image ? '<img src="' + esc(r.image) + '" alt="" loading="lazy">' : '') +
        (!r.missing && !r.available ? '<span class="wl-soldtag">売り切れ</span>' : '') +
      '</a>' +
      (shared ? '' : '<button type="button" class="wl-remove" data-wl-remove="' + v + '" aria-label="お気に入りから削除">' + X + '</button>') +
      '<a class="wl-card__name" href="' + esc(r.url) + '">' + esc(r.title) + '</a>' +
      (r.variantTitle ? '<div class="wl-card__variant">' + esc(r.variantTitle) + '</div>' : '') +
      (r.missing ? '' : '<div class="wl-card__price">' + yen(r.price) + '</div>') +
      stockHtml(r) +
      actionHtml(r, true) +
      (r.item.a && !shared ? '<div class="wl-card__date">' + esc(jdate(r.item.a)) + ' に追加</div>' : '') +
    '</div>';
  }
  /* ================================================================
     一覧(専用ページ)
     ================================================================ */
  var renderToken = 0;
  var lastResolved = {};   // v → 解決済みの商品情報(すべてカートに追加・取り込みで使う)

  function listItems(el) {
    return el.__sharedItems || state.items;
  }
  function renderList(el) {
    var mode = 'grid';
    var shared = !!el.__sharedItems;
    var items = listItems(el);
    var token = ++renderToken;
    el.__token = token;
    if (!items.length) {
      el.innerHTML = emptyHtml(shared);
      return;
    }
    el.innerHTML = skeletonHtml(mode, Math.min(items.length, 8));
    Promise.all(items.map(resolveItem)).then(function (rs) {
      if (el.__token !== token) return;
      rs.forEach(function (r) { lastResolved[r.item.v] = r; });
      el.innerHTML = rs.map(function (r) { return cardHtml(r, shared); }).join('');
    });
  }
  function renderAll() {
    document.querySelectorAll('[data-wl-list]').forEach(renderList);
    updateHeader();
    updateProductButton();
    updateFooters();
  }
  function updateHeader() {
    var n = state.items.length;
    document.querySelectorAll('.wl-header__count').forEach(function (b) {
      b.hidden = n === 0;
      var s = b.querySelector('.wl-header__n');
      if (s) s.textContent = n < 100 ? String(n) : '99+';
    });
    document.querySelectorAll('[data-wl-count-label]').forEach(function (el) {
      var pageEl = el.closest('[data-wl-page]');
      var list = pageEl ? pageEl.querySelector('[data-wl-list]') : null;
      var count = list && list.__sharedItems ? list.__sharedItems.length : n;
      el.textContent = count + '点';
    });
  }
  function updateFooters() {
    var n = state.items.length;
    document.querySelectorAll('[data-wl-addall], [data-wl-share], [data-wl-clear]').forEach(function (b) {
      var pageEl = b.closest('[data-wl-page]');
      var list = pageEl ? pageEl.querySelector('[data-wl-list]') : null;
      var count = list && list.__sharedItems ? list.__sharedItems.length : n;
      b.hidden = count === 0;
    });
    document.querySelectorAll('[data-wl-page-foot]').forEach(function (f) {
      var pageEl = f.closest('[data-wl-page]');
      var list = pageEl ? pageEl.querySelector('[data-wl-list]') : null;
      f.hidden = (list && list.__sharedItems) ? true : n === 0;
    });
  }

  /* ================================================================
     一覧ページへ(ドロワーは廃止。ヘッダーのハートも普通のリンク)
     ================================================================ */
  function openPage() { location.href = CFG.pageUrl; }

  /* ================================================================
     トースト
     ================================================================ */
  var toastEl = document.getElementById('WishlistToast');
  var toastTimer = null;
  function toast(msg, actionLabel, actionFn) {
    if (!toastEl) return;
    toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + (actionLabel ? '<button type="button" class="wl-toast__action">' + esc(actionLabel) + '</button>' : '');
    var btn = toastEl.querySelector('.wl-toast__action');
    if (btn) btn.addEventListener('click', function () { hideToast(); if (actionFn) actionFn(); });
    toastEl.hidden = false;
    requestAnimationFrame(function () { toastEl.classList.add('is-show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 3200);
  }
  function hideToast() {
    if (!toastEl) return;
    toastEl.classList.remove('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 300);
  }

  /* ================================================================
     カートに追加(Dawn のカート通知/ドロワーを更新する)
     ================================================================ */
  function cartTarget() {
    var d = document.querySelector('cart-drawer');
    if (d) return { el: d, sections: 'cart-drawer,cart-icon-bubble' };
    var n = document.querySelector('cart-notification');
    if (n) return { el: n, sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble' };
    return { el: null, sections: 'cart-icon-bubble' };
  }
  function addToCart(variantIds) {
    var ids = variantIds.map(function (v) { return Number(v); }).filter(function (n) { return n > 0; });
    if (!ids.length) return Promise.resolve();
    var target = cartTarget();
    var payload = ids.length === 1
      ? { id: ids[0], quantity: 1, sections: target.sections, sections_url: location.pathname }
      : { items: ids.map(function (id) { return { id: id, quantity: 1 }; }), sections: target.sections, sections_url: location.pathname };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'error');
        var data = res.data;
        if (ids.length > 1 && data.items && data.items.length) data.key = data.items[data.items.length - 1].key;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist', productVariantId: ids[0], cartData: data }); } catch (e) { /* ignore */ }
        }
        if (target.el && typeof target.el.renderContents === 'function' && data.sections) {
          try { target.el.renderContents(data); } catch (e) { refreshBubble(data); }
        } else {
          refreshBubble(data);
        }
        if (ids.length > 1) toast(ids.length + '点をカートに追加しました', 'カートを見る', function () { location.href = '/cart'; });
      })
      .catch(function (e) {
        toast('カートに追加できませんでした。' + (e && e.message && e.message !== 'error' ? e.message : ''));
      });
  }
  function refreshBubble(data) {
    try {
      var html = data.sections && data.sections['cart-icon-bubble'];
      var el = document.getElementById('cart-icon-bubble');
      if (html && el) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#cart-icon-bubble');
        if (fresh) el.innerHTML = fresh.innerHTML;
      }
    } catch (e) { /* ignore */ }
  }

  /* ================================================================
     共有リンク
     ================================================================ */
  function shareUrl(items) {
    var parts = items.map(function (i) { return i.h + ':' + i.v; });
    return location.origin + CFG.pageUrl + '?v=' + encodeURIComponent(parts.join(','));
  }
  function share(items) {
    if (!items.length) return;
    var url = shareUrl(items);
    if (navigator.share) {
      navigator.share({ title: 'お気に入り', url: url }).catch(function () { /* キャンセル */ });
      return;
    }
    var done = function () { toast('共有リンクをコピーしました'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('このリンクをコピーしてください', url); });
    } else {
      window.prompt('このリンクをコピーしてください', url);
    }
  }
  function parseShared() {
    var m = location.search.match(/[?&]v=([^&]+)/);
    if (!m) return null;
    var out = [];
    decodeURIComponent(m[1]).split(',').forEach(function (part) {
      var hv = part.split(':');
      if (hv.length === 2 && /^[a-z0-9_-]+$/i.test(hv[0]) && /^\d+$/.test(hv[1])) {
        out.push({ v: hv[1], h: hv[0].toLowerCase(), s: '', t: '', p: '', a: '' });
      }
    });
    return out;
  }

  /* ================================================================
     商品ページの♡ボタン
     ================================================================ */
  var prod = document.querySelector('.wl-product');
  var prodVariants = {};
  var prodCurrent = null;
  if (prod) {
    try { prodVariants = JSON.parse(prod.querySelector('.wl-product__variants').textContent) || {}; } catch (e) { prodVariants = {}; }
  }
  function relocateProductButton() {
    if (!prod) return;
    var form = document.querySelector('product-form');
    var buttons = form ? form.querySelector('.product-form__buttons') : null;
    if (!buttons) return;
    var after = buttons;
    var restock = form.querySelector('.restock');
    if (restock) after = restock;
    if (after.nextSibling !== prod) after.parentNode.insertBefore(prod, after.nextSibling);
  }
  function readProductCurrent() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!input) return null;
    var v = prodVariants[String(input.value)];
    if (!v) return null;
    return { id: String(input.value), sku: v.sku || '', title: v.title || '', available: !!v.available };
  }
  function updateProductCurrent(variant) {
    if (variant && variant.id) {
      var v = prodVariants[String(variant.id)] || {};
      prodCurrent = { id: String(variant.id), sku: variant.sku || v.sku || '', title: variant.title || v.title || '', available: typeof variant.available === 'boolean' ? variant.available : !!v.available };
    } else {
      prodCurrent = readProductCurrent();
    }
    updateProductButton();
  }
  function updateProductButton() {
    if (!prod) return;
    if (!prodCurrent) { prod.hidden = true; return; }
    prod.hidden = false;
    var on = has(prodCurrent.id);
    var btn = prod.querySelector('.wl-product__btn');
    var label = prod.querySelector('.wl-product__label');
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    label.textContent = on ? 'お気に入りに追加済み' : 'お気に入りに追加';
  }
  function toggleProduct() {
    if (!prodCurrent) return;
    if (has(prodCurrent.id)) {
      remove(prodCurrent.id);
      toast('お気に入りから削除しました');
    } else {
      add({ v: prodCurrent.id, h: prod.getAttribute('data-handle'), s: prodCurrent.sku, t: prodCurrent.title === 'Default Title' ? '' : prodCurrent.title, p: prod.getAttribute('data-product-title') || '' });
      toast('お気に入りに追加しました', 'お気に入りを見る', openPage);
    }
  }

  /* ================================================================
     専用ページ(共有リンクの受け側を含む)
     ================================================================ */
  function initPage() {
    var page = document.querySelector('[data-wl-page]');
    if (!page) return;
    var list = page.querySelector('[data-wl-list]');
    var shared = parseShared();
    if (shared && shared.length) {
      list.__sharedItems = shared;
      var box = page.querySelector('[data-wl-shared]');
      if (box) box.hidden = false;
      var title = page.querySelector('[data-wl-page-title]');
      if (title) title.textContent = '共有されたお気に入り';
      var sub = page.querySelector('[data-wl-page-sub]');
      if (sub) sub.textContent = 'このリンクを送った人のお気に入りです。気に入った商品は「取り込む」で自分のお気に入りに入れられます。';
      var note = page.querySelector('[data-wl-loginnote]');
      if (note) note.hidden = true;
      var imp = page.querySelector('[data-wl-import]');
      if (imp) imp.addEventListener('click', function () {
        var n = 0;
        shared.forEach(function (i) {
          var r = lastResolved[i.v];
          if (r && r.missing) return;
          if (add({ v: i.v, h: i.h, s: r ? r.sku : '', t: r ? r.variantTitle : '', p: r ? r.title : '' }, true)) n++;
        });
        emit();
        toast(n + '点を自分のお気に入りに取り込みました', '自分のお気に入りを見る', function () { location.href = CFG.pageUrl; });
      });
    }
  }

  /* ================================================================
     イベント
     ================================================================ */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wl-remove], [data-wl-cart], [data-wl-addall], [data-wl-share], [data-wl-clear], .wl-product__btn');
    if (!t) return;
    if (t.classList.contains('wl-product__btn')) { toggleProduct(); return; }
    if (t.hasAttribute('data-wl-remove')) {
      remove(t.getAttribute('data-wl-remove'));
      toast('お気に入りから削除しました');
      return;
    }
    if (t.hasAttribute('data-wl-cart')) {
      t.disabled = true;
      addToCart([t.getAttribute('data-wl-cart')]).then(function () { t.disabled = false; });
      return;
    }
    if (t.hasAttribute('data-wl-addall')) {
      var page = t.closest('[data-wl-page]');
      var list = page ? page.querySelector('[data-wl-list]') : null;
      var items = list && list.__sharedItems ? list.__sharedItems : state.items;
      var ids = items.filter(function (i) { var r = lastResolved[i.v]; return r && !r.missing && r.available; }).map(function (i) { return i.v; });
      if (!ids.length) { toast('カートに追加できる在庫ありの商品がありません'); return; }
      t.disabled = true;
      addToCart(ids).then(function () { t.disabled = false; });
      return;
    }
    if (t.hasAttribute('data-wl-share')) {
      var pg = t.closest('[data-wl-page]');
      var ls = pg ? pg.querySelector('[data-wl-list]') : null;
      share(ls && ls.__sharedItems ? ls.__sharedItems : state.items);
      return;
    }
    if (t.hasAttribute('data-wl-clear')) {
      if (state.items.length && window.confirm('お気に入りをすべて削除しますか？')) {
        clearAll();
        toast('お気に入りをすべて削除しました');
      }
    }
  });

  // バリエーション切り替え(Dawn の pubsub)。念のため select/radio の change も聞く
  if (prod) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data ? event.data : {};
        if (data.sectionId && data.sectionId !== prod.getAttribute('data-section')) return;
        updateProductCurrent(data.variant || null);
      });
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, variant-radios')) {
        setTimeout(function () { updateProductCurrent(null); }, 80);
      }
    });
  }

  // 他のタブで変わったら追随
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { state = load(); renderAll(); }
  });

  /* ================================================================
     初期化
     ================================================================ */
  function init() {
    relocateProductButton();
    updateProductCurrent(null);
    initPage();
    renderAll();
    // 商品DBの一覧を取りに行く(未送信の変更があれば一緒に送る)
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 他のスクリプトから使えるように
  CFG.has = has;
  CFG.add = add;
  CFG.remove = remove;
  CFG.open = openPage;
  CFG.items = function () { return state.items.slice(); };
  CFG.sync = sync;
})();
